import React, { useEffect, useState, useRef } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";


function RefreshCountdonwn({ refreshInterval = 15, resetSignal = 0 }) {
    const [countdown, setCountdown] = useState(refreshInterval);
    const countdownRef              = useRef(refreshInterval);

    // Reset when the parent signals a new fetch has completed
    useEffect(() => {
        countdownRef.current = refreshInterval;
        setCountdown(refreshInterval);
    }, [resetSignal, refreshInterval]);

    // 1-second tick
    useEffect(() => {
        const tickId = setInterval(() => {
            countdownRef.current = Math.max(0, countdownRef.current - 1);
            setCountdown(countdownRef.current);
        }, 1000);
        return () => clearInterval(tickId);
    }, []);

    const isUrgent = countdown <= 3;

    return (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.75,
                    px: 1.5,
                    py: 0.5,
                    borderRadius: "20px",
                    bgcolor: isUrgent ? "#fff8e1" : "#e8f0fe",
                    border: "0.5px solid",
                    borderColor: isUrgent ? "warning.200" : "primary.200",
                }}
            >
                <Typography variant="caption" sx={{ color: "text.secondary", fontSize: "0.78rem" }}>
                    Next refresh in
                </Typography>
                <Typography
                    variant="caption"
                    sx={{
                        fontWeight: 700,
                        fontSize: "0.78rem",
                        color: isUrgent ? "warning.main" : "primary.main",
                        minWidth: 18,
                        textAlign: "right",
                    }}
                >
                    {countdown}s
                </Typography>
                <CircularProgress
                    variant="determinate"
                    value={(countdown / refreshInterval) * 100}
                    size={18}
                    thickness={5}
                    sx={{ color: isUrgent ? "warning.main" : "primary.main" }}
                />
            </Box>
        </Box>
    );
}

export default RefreshCountdonwn;